import environment from "./environments/environment";
//STATUS
export const IS_ACTIVE_YES = "Y";
export const IS_ACTIVE_NO = "N";
export const IS_ACTIVE_UPLOAD = "U";
export const IS_Active_Yes = "Yes";
export const IS_Active_No = "No";
export const IS_Status_ACTIVE = "Active";
export const IS_Status_INACTIVE = "Inactive";
export const IS_Status_OPEN = "OPEN";
//ACTION TYPE
export const IS_Status_DEACTIVATE = "Deactivate";

//ACTION TYPE
export const ACTION_TYPE_DRAFT = "createOrUpdateProject";
export const ACTION_TYPE_SUBMIT = "submitProject";

//API RESPONSE TYPE
export const API_RESPONSE_TYPE_SUCCESS = "Success";
export const API_RESPONSE_TYPE_WARNING = "Warning";
export const API_RESPONSE_TYPE_FAILURE = "Failure";
export const API_RESPONSE_TYPE_FAILED = "Failed";
export const API_RESPONSE_TYPE_SUBMISSION_FAILED = "Submission Failed";

export const UPDATE_HISTORY = "UPDATE_HISTORY";

//Roles
export const ROLES_ADMIN_MANAGER = "ADMIN_MANAGER";
export const ROLES_ADMIN_USER = "ADMIN_USER";
export const ROLES_PARTICIPANT_USER = "PARTICIPANT_USER";
export const ROLES_READ_ONLY_USER = "READ-ONLY"; //rename as Read only user to READ-ONLY
export const ROLES_READ_ONLY_ALL_LOCATIONS = "READ_ONLY_ALL_LOCATIONS";
export const ROLES_PROJECT_MANAGER = "PROJECT_MANAGER";
export const ROLES_PROJECT_APPROVER = "PROJECT_APPROVER"; //rename as project approver to pastor  // befre PASTOR
export const ROLES_PROJECT_ANALYST = "PROJECT_ANALYST";
export const ROLES_BUDGET_ANALYST = "BUDGET_ANALYST";
export const ROLES_FINANCIAL_ANALYST = "FINANCIAL_ANALYST";
export const ROLES_BUSINESS_MANAGER = "BUSINESS_MANAGER";

//Role Names
export const PROJECT_MANAGER = "Project Manager"
export const PROJECT_APPROVER = "Project Approver"
export const BUSINESS_MANAGER = "Business Manager"


//TASK STATUS
export const TASK_STATUS_OPEN = "Open";
export const TASK_STATUS_PENDING = "Pending";
export const TASK_STATUS_COMPLETED = "Completed";
export const TASK_STATUS_APPROVED = "Approved";
export const TASK_STATUS_REJECTED = "Rejected";
export const TASK_STATUS_REQURIES_ADDITIONAL_DOCUMENTATION =
  "Requires Additional Documentation";
export const TASK_STATUS_IN_PROGRESS = "In-progress";
//PROJECT STATUS
export const PROJECT_STATUS_APPROVED = "Approved";
export const PROJECT_STATUS_CANCELLED = "Cancelled";
export const PROJECT_STATUS_CANCEL = "Cancel";
export const PROJECT_STATUS_DRAFT = "Draft";
export const PROJECT_STATUS_PENDING_FOR_APPROVAL = "Pending for Approval";
export const PROJECT_STATUS_ALL = "All";
export const PROJECT_STATUS_SUBMIT = "Submit";
export const PROJECT_INVOICE_SUBMITTED = "Invoice Submitted";

//INVOICE STATUS  
export const INVOICE_STATUS_POSTED_TO_NETSUITE = "Posted to Netsuite";
export const INVOICE_STATUS_COMPLETE = "Complete";
export const INVOICE_STATUS_PENDING = "Pending";
export const INVOICE_STATUS_PENDING_FOR_SITE_APPROVAL = "Pending for Site Approval";

//Upload Documents
export const MAX_LENGTH = 150;
export const MAX_SIZE = 17000000;
export const MAX_SIZEMAX_SIZE = 0;

//ADDITIONAL LINKS Policies, Practices & Stakeholders

export const ADDITIONAL_LINK_CAPITAL_PROJECT_APPROVAL_PROCESS =
  "https://ocrcbo.sharepoint.com/sites/rcborealestate/SitePages/Capital-Projects.aspx";
export const ADDITIONAL_LINK_PRACTICES_PRACTICES_STAKEHOLDERS =
  "https://ocrcbo.sharepoint.com/sites/rcborealestate/SitePages/Policies-and-Procedures.aspx";
export const ADDITIONAL_LINK_THE_CONSTRUCTION_PROCESS =
  "https://ocrcbo.sharepoint.com/sites/rcborealestate/SitePages/THe.aspx";

//USER VALIDATION
export const USER_VALIDATION_USER_DOSE_NOT_HAVE_ACCESS_TO_FISCIAL_APP =
  "User does not have access to FISCAL.\nPlease contact the Admin.";
export const UNABLE_TO_REACH_FISCAL_SYSTEM_TO_GET_THE_INFORMATION =
  "Unable to reach Fiscal system to get the information.";

//Shareepoint BaseUrl
export const SHAREPOINT_BASEURL = "https://ocrcbo.sharepoint.com/sites/fiscal-np/" + environment.documentEnvironment;

//Tocken Refresh Time
export const TOCKEN_REFRESH_TIME_IN_SEC = 300; // 5 minutes before token expiry

//Allowed Roles For Funds

export const FUND_ALLOWED_ROLES: string[] = [
  ROLES_ADMIN_MANAGER,
  ROLES_ADMIN_USER,
  ROLES_PARTICIPANT_USER,
];
export const LOAN_ALLOWED_ROLES: string[] = [
  ROLES_ADMIN_MANAGER,
  ROLES_ADMIN_USER,
];
export const ADMIN_VIEW_ALLOWED_ROLES: string[] = [
  ROLES_ADMIN_MANAGER,
  ROLES_ADMIN_USER,
  ROLES_BUDGET_ANALYST,
];
export const PARTICIPANT_INTEREST_ROLES: string[] = [
  ROLES_ADMIN_MANAGER,
  ROLES_FINANCIAL_ANALYST,
];
export const MONTHLY_CALCULATIONS_ROLES: string[] = [
  ROLES_ADMIN_MANAGER,
  ROLES_ADMIN_USER,
];

//menu items

export const NEW_FUND = "newFund";

//Summary Page

export const ACCOUNT_SUMMARY_LOAN_PAYABLE = "Loans Payable";
export const ACCOUNT_SUMMARY_CREDIT_LINE = "Credit Line";

// G/L Adjustments
export const LOAN_PAYABLE = "Loan Payable";
export const EQUITY = "Equity";

//code
export const STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  REDIRECTION: 300,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};

export const ACCOUNT_SUMMARY_NAME = {
  EQUITY_NAME: "Equity",
  REVENUE_NAME: "Revenue"
}

export const ATTRIBUTE_NAME = {
  PROFILE_MENU: "menu_position",
  SETTING_GRACE_PERIOD: "grace_period",
  SETTING_TODAY_SYSDATE_TEST_ENV_ONLY: "today-sysdate-test-env-only",
  SETTING_MONTH_END: "MONTH_END",
  SETTING_MONTHLY: "interest_calculation_method",
};

//Naviagte Path
export const PATH_LOAN_SUMMARY_PARTICIPANT = "/loanSummary";
export const PATH_CREDITLINE_SUMMARY_PARTICIPANT = '/creditLineSummaryListing';

//ADMIN OR PARTICIPANT VIEW
export const ADMIN_VIEW = "Admin View";
export const PARTICIPANT_VIEW = "Participant View";

//RESPONSE
export const RESPONSE_SUBMITTED = "Submitted";

//PERIOD
export const PERIOD_MONTHLY = "MONTHLY";
export const PERIOD_QUARTERLY = "QUARTERLY";
export const PERIOD_SEMIANNUALLY = "SEMIANNUALLY";
export const PERIOD_YEARLY = "YEARLY";

// Yearly Type Values
export const YEARLY_TYPE_MONTHLY_VALUES = "monthly_values";
export const YEARLY_TYPE_ANNUAL = "annual";
export const YEARLY_TYPE_MONTHLY_VALUES_MONTHLY = "monthly";

//TYPE
export const TYPE_ACTUAL = "Actual";
export const TYPE_ACTUALS = "Actuals";
export const TYPE_BUDGET = "Budget";

//MonthlyList
export const MONTHLY_LIST_NUMBER = 18;
export const PARTICIPANT_MONTHLY_LIST_NUMBER = 48;

// ERROR VALIDATION MESSAGE
export const ERROR_VALIDATION_MESSAGE_NO_VALUE_HAVE_BEEN_MODIFIED = "No fields or values have been modified. Please ensure there are changes before submitting.";
export const ERROR_VALIDATION_MESSAGE_MAPPING_DETAILS_IS_REQURIED = "Mapping Details is required for all the accounts."
export const ERROR_VALIDATION_MESSAGE_ERROR_OCCURRED_WHILE_FETCHING_THE_MASTER_CHART_ACCOUNT_DETAILES = "Error occurred while fetching the Master Chart Account Details."
export const ERROR_VALIDATION_MESSAGE_ERROR_OCCURRED_WHILE_POSTING_THE_EXCEL_SHEET_DETAILES = "Error occurred while posting the excel sheet details."
export const ERROR_VALIDATION_MESSAGE_NO_VALID_DATA_TO_IMPORT_PLEASE_CHECK_GL_MAPPINGS = "No valid data to import. Please check GL Mappings."
export const SESSION_TIMEOUT_DURATION = 60 * 60 * 1000; // 60 minutes in milliseconds
export const AUTH_SERVICES_VALIDATION = "Authentication service is currently unavailable.\nPlease contact admin."

// PATHS
export const CLIENT_STATEMENT_PATH = "/clientstatement";
export const LOAN_STATEMENT_PATH = "/loanstatement";
export const PARTICIPANT_SUMMARY_PATH = "/participantSummary";
export const MONTHLY_STATEMENT_PATH = "/monthlyStatement";
export const ADMIN_VIEW_PATH = "/adminView";
export const SWITCH_PARTICIPANT_PATH = "/switchParticipant";
export const RCBO_SUMMARY_PATH = "/rcboSummary";
export const ENTER_FUND_DETAILS_PATH = "/enterFundDetails";
export const SETTING_SUMMARY_SCREENS_PATH = "/settingSummaryScreens";
export const VENDOR_INVOICE_PATH = "/vendorInvoiceSummary";
export const NETSUITE_LOG_PATH = "/netSuiteLog";
export const USER_LISTING_PATH = "/userListing";

export const SELECT_PLACEHOLDER = "Select";
//Waiting Approvals
export const WAITNG_FOR_PROJECT_APPROVAL_TASK = "Waiting for Project Approval";
export const WAITNG_FOR_BM_APPROVAL_TASK = "Waiting for BM Approval";
export const WAITNG_FOR_PM_APPROVAL_TASK = "Waiting for PM Approval";
export const BM_REJECTED = "BM Rejected";
export const PM_REJECTED = "PM Rejected";
export const CM_REJECTED = "CM Rejected";
export const PENDING_SITE_APPROVAL = "Pending Site Approval";

//notify constant of either success or error 
export const NOTIFY_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

//User
export const ERROR_DELETEING_USER = "An error occurred while delete the user data: ";
export const ERROR_FETCHING_USER = "An error occurred while fetching user data: "

//Invoice
export const ERROR_DELETING_INVOICE = "An error occurred while deleting the invoice.";
export const ERROR_SAVING_INVOICE = "An error occurred while saving the invoice.";

//fileTypes
export const FILE_TYPE_PDF = "pdf";
export const FILE_TYPE_CSV = "csv";
export const FILE_TYPE_TXT = "txt";

//file Name hardcoded for downloand in account summary section
export const FILE_NAME_PDF = "transaction.pdf";
export const FILE_NAME_CSV = "transaction.csv";
export const FILE_NAME_TXT = "transaction.txt";

//Error in Summary details page
export const UNSUPPORTED_FILE_TYPE = "Unsupported file type.";
export const AN_UNEXPECTED_ERROR_OCCURED = "An unexpected error occurred";
export const SOMETHING_WENT_WORNG = "Something went wrong";
export const ERROR_IN_MASTER_TRANSACTION = "An unexpected error occurred while fetching the master transaction";
export const NO_IMAGE_TO_PRINT = "No image to print";
export const FRONT_AND_BANK_IMAGES_ARE_NOT_LOADED_YET = "Front and Back images are not loaded yet";

//Label and submenu items
export const LABEL_NAME_REPORTS = "reports";
export const SUBMENU_NAME_PARTICPANT_SUMMARY = "participantSummary";
export const LABEL_NAME_SETTINGS = "settings";
export const LABEL_NAME_SETUPQBO = "setUpqbo";
export const LABEL_NAME_INVOICES = "invoices";
export const SUBMENU_NAME_RCBOINVOICES = "rcboInvoices";
export const SUBMENU_NAME_INVOICESTASKS = "invoiceTasks";

//Client Name
export const CLIENT_NAME_RCBO = "RCBO";
export const CLIENT_NAME_DC_GARY = "DC Gary";

//Q B O
export const QBO = "QBO";
export const QBE = "QBE";

//Options 
export const OPTION_ALL = "All";

//netsuit debit account number
export const NETSUITE_DEBIT_ACCOUNT_NUMBER = "2260.12";

// Maximum allowed currency amount: up to eight digits before decimal and two decimal places, max $99,999,999.99.
export const MAX_AMOUNT_ALLOWED = 99999999.99;

//Maximum allowed percentage (interest rate) — value is an integer percent (0-100). Example: 99 === 99%
export const MAX_PERCENTAGE_ALLOWED = 99;

//allowed payment types
export const ALLOWED_PAYMENT_TYPES_DNL = "DNL";
export const ALLOWED_PAYMENT_TYPES_NON_DNL = "NON-DNL";
